import React from 'react'
import classNames from 'classnames'

import { StateProvider, getHTML } from '../../core'
import MediaWithContent from '../MediaWithContent'

import './values.scss'

class MapSection extends React.Component {
  render() {
    const data = this.props.data || {}
    const context = this.props.context || {}

    const { 
      title,
      values,
    } = data

    return (
      <section styleName="values-wrapper">
        <h1>{title}</h1>
        <div styleName="values">
          {(values || []).map((value, i) => {
            if (!value) {
              return null
            }
        
            return (
              <div styleName="value" key={i}>
                <div 
                  styleName="image"
                  style={{ backgroundImage: `url(${value.image.resize.src})`}}
                />
                <h3>{value.title}</h3>
                <div dangerouslySetInnerHTML={getHTML(value.description)} />
              </div>
            )
          })}
        </div>
      </section>
    )
  }
}

export default MapSection